import { useQuery } from '@tanstack/react-query';
import api from 'services/api/api';

export const getModel = async () => {
	const response = await api.get('/modelo');
	return response.data;
};
export const useModelList = () => {
	return useQuery(['model-list'], getModel, {
		refetchOnWindowFocus: false,
	});
};
